import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-brand rounded-full shadow-[0_8px_20px_-6px_rgba(185,62,8,0.45)] hover:bg-brand-dark transition-[background-color,box-shadow,transform] duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-dark focus-visible:ring-offset-2 focus-visible:ring-offset-base';
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.04
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.16,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-40" data-mp="30qqiykmzlxea">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.04
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.16,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-41" data-mp="3auisqzxcc23">
      {children}
    </motion.button>;
}